namespace Ir.Components.Workbook.ToolBar.CreateReportToolBar {
    interface ICreateReportToolBarViewModel {
        buttonOptions: DevExpress.ui.dxButton.Properties;
        buttonComponent: DevExpress.ui.dxButton;
        element: any;

        templates: Array<any>;
    }

    interface IParams {
        isWidgetButton: boolean;
        widgetType: WidgetType;
        text?: string;
        popoverClass?: string;
    }

    export function getViewModel(this: ICreateReportToolBarViewModel, params: IParams, componentInfo) {
        let self = this;
        this.element = componentInfo.element;
        this.buttonOptions = {
            hint: params.isWidgetButton ? `Add a new ${BaseWidget.getWidgetText(params.widgetType)} Widget` : "Add a new tab using a Report Template",
            template: params.isWidgetButton ? `<i class="ms">${BaseWidget.getWidgetIcon(params.widgetType)}</i> ${BaseWidget.getWidgetText(params.widgetType)}` : `<i class="ms ms-white ms-bold">add</i>${(params.text ?? " Report")}`,
            stylingMode: 'contained',
            type: params.isWidgetButton ? "normal" : "success",
            onClick(e) {
                showCreateNewReportPopover(self, params);
            },
            onInitialized(e) {
                self.buttonComponent = e.component;  
            },
            visible: workbook.workbookConfig.generalSettings.editing as any,
            elementAttr: {
                class: params.isWidgetButton ? "intro-add-widget-button" : "apply-backgroundColor intro-add-widget-button"
            },
        }

        this.templates = workbook.workbookConfig.getReportTemplateListForNewReport();
        if (params.isWidgetButton) {
            let designKeyValue = this.templates.find(x => x.key === KeyReportStubTypeEnum.Design);
            let createEmptyOption = designKeyValue.items.find(x => x.id === NewReportStubTypeEnum.Empty);
            let type = NewReportStubTypeEnum.Report;
            let reportType = ReportTypeEnum.Analysis;
            switch (params.widgetType) {
                case WidgetType.Chart:
                    type = NewReportStubTypeEnum.Chart;
                    reportType = ReportTypeEnum.Chart;
                    createEmptyOption.name = "Create Empty Chart";
                    break
                case WidgetType.Pivot:
                    type = NewReportStubTypeEnum.Pivot;
                    reportType = ReportTypeEnum.Pivot;
                    createEmptyOption.name = "Create Empty Pivot";
                    break
                default:
                    break
            }
            designKeyValue.items = designKeyValue.items.filter(x => x.id === type || x.id === NewReportStubTypeEnum.Empty);
            for (let keyVal of this.templates) {
                for (let item of keyVal.items) {
                    item.type = reportType;
                }
            }
        }
    }

    function showCreateNewReportPopover(self: ICreateReportToolBarViewModel, params: IParams) {
        let popover = $('.createNewReportPopover', self.element).data("dxPopover");
        if (!popover) {
            let listComponent: DevExpress.ui.dxList = null;
            let sortDatabase = () => {
                self.templates.forEach(item => {
                    if (item.key === KeyReportStubTypeEnum.Templates && Array.isArray(item.items)) {
                        item.items = item.items.sort(MappingService.sortFields);
                    }
                });
            }

            sortDatabase();
            popover = $('.createNewReportPopover', self.element).dxPopover({
                contentTemplate: function () {
                    let container = $("<div>");
                    $("<div class='createNewReportPopoverList'>").dxList({
                        searchEnabled: true,
                        searchExpr: ["name"],
                        dataSource: self.templates,
                        height: '100%',
                        grouped: true,
                        groupTemplate(data) {
                            return "";
                        },
                        itemTemplate(data: ReportStub) {
                            let displayName = replaceBasicHtmlContent(data.name);
                            return $(`<div><i class="ms">${data.icon}</i><span style="vertical-align: top;">  ${displayName}</span></div>`);
                        },
                        onItemClick(e) {
                            let tabType = TabTypeEnum.Report;
                            if (e.itemData.type === ReportTypeEnum.Chart) {
                                tabType = TabTypeEnum.Chart;
                            }

                            if (params.isWidgetButton) {
                                workbook.workbookConfig.activeTab().dashboard.addWidget(params.widgetType, e.itemData.id);
                            }
                            else {
                                workbook.workbookConfig.workbookHelper.addTab(tabType, e.itemData);
                            }

                            popover.hide();
                        },
                        onInitialized(e) {
                            listComponent = e.component;
                        },
                        onOptionChanged(e) {
                            if (e.name === "searchValue") {
                                setTimeout(() => {
                                    popover.repaint();
                                }, 0);
                            }
                        }
                    }).appendTo(container);

                    container.dxScrollView({
                        width: '100%',
                        height: '100%',
                    });

                    return container;
                },
                target: self.buttonComponent.$element()[0],
                showEvent: 'dxclick',
                position: 'bottom',
                width: 220,
                maxHeight: "80%",
                visible: false,
                wrapperAttr: {
                    class: params.popoverClass,
                },
                title: "Report Templates",
                showTitle: true,
                toolbarItems: [{
                    widget: "dxButton",
                    location: "after",
                    options: {
                        icon: "ms ir-sort-by-alpha-icon",
                        hint: "Sort alphabetically",
                        elementAttr: {
                            class: `ir-sort-fields ${loggedUser.alphabeticalOrder ? "selected" : ""}`
                        },
                        onClick(e) {
                            loggedUser.alphabeticalOrder = !loggedUser.alphabeticalOrder;
                            if (e.element.hasClass("selected")) {
                                e.element.removeClass("selected");
                            }
                            else {
                                e.element.addClass("selected");
                            }

                            sortDatabase();
                            listComponent.option("dataSource", self.templates);
                        }
                    }
                }]
            }).dxPopover("instance");
        }

        popover.show();
    }
}